import ParametrosModel from "@/models/cadastros/saude/ParametrosModel";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Api from "./Api";
import { servicosSaudeApiConfig } from "./config";

class ServicosSaudeParametrosApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  obterParametros() {
    return this.get("/parametros")
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw new Error("Erro ao obter parêmtros");
      });
  }

  atualizarParametros(parametros: ParametrosModel): Promise<string> {
    return this.put<any>(`/parametros`, parametros)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }
}

export const servicosSaudeParametrosApi = new ServicosSaudeParametrosApi(servicosSaudeApiConfig);
